<template>
  <a-layout class="create-application-box">
    <a-card class="create-application" :bordered=false>
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
        <span class="page-status " :class="{'page-status-yellow':params.status==='审批中','page-status-green':params.status==='审批通过'||params.status==='付款成功','page-status-red':params.status==='审批拒绝'||params.status==='付款失败','page-status-gray':params.status==='已撤回'}">{{params.status}}</span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && loadedLayout ">
        <common-form v-if="layout.type==='commonForm'" :ref="'commonForm'" :layout="layout" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange"></common-form>
        <upload v-if="layout.type==='upload'" :layout="layout" :default-file-none="defaultFillNone" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <adjust-table v-if="layout.type==='budgetAdjustTable'" :layout="layout" :columns="columns" :edit-columns="editColumns" :param="params[layout.field]" :can-edit="canEdit" @update-data="updateTable"></adjust-table>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'必填信息填写后，流程将自动显示'" v-if="loadedInfo && loadedLayout"></approval-flow>
      <a-row class="footer" v-if="params.process_status && loadedInfo && loadedLayout" style="margin-top:20px;">
        <a-col :xs="6" :sm="4"></a-col>
        <a-col :xs="14" :sm="20">
          <a-button type="primary" @click="approval(1)" style="width:120px;margin-right:18px;">批准</a-button>
          <a-button @click="approval(0)" style="width:120px;margin-right:18px;">退回</a-button>
          <a-button @click="visibleComment = true" style="width:120px;">评论</a-button>
        </a-col>
      </a-row>
      <div style="text-align:center" v-if="!loadedInfo || !loadedLayout">
        <a-spin tip="数据加载中..."></a-spin>
      </div>
    </a-card>
    <form-modal :basic-modal="approvalModal" :form-layout="approvalInfolModal" :confirm-loading="confirmLoading" @submit="approvalModalSubmit" @cancel="approvalModalCancel"></form-modal>
    <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
  </a-layout>
</template>

<script>
import moment from "moment";
import UUID from "uuidjs";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { data } from "../../data/mockData.js";
import { layoutConfigDetail, mockParamsDetail } from "../../utils/mockData.js";
import AdjustTable from "../../components/AdjustTable.vue";
import CommonForm from "../../components/CommonForm.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import Upload from "../../components/Upload.vue";
import FormModal from "../../components/FormModal.vue";
import { getApprovalFlow, sendComment } from "../../services/CommonService.js";
import {
  UpdateData,
  COLUMNS,
  passApplicationApi,
  rejectApplicationApi,
  getBudgetChangeDetailParams,
  approvalApplication,
  getBudgetChangeLayout,
  getBudgetDetailApprovalFlow,
  getBudgetChangeDetailInfo
} from "../../services/BudgetChangeService.js";
import {
  backInfoFormModal,
  agreeInfoFormModal
} from "../../data/formModalConfigs.js";
let columns = _.cloneDeep(COLUMNS);
columns.splice(columns.length - 1, 1);

export default {
  components: {
    AdjustTable,
    CommonForm,
    ApprovalFlow,
    Upload,
    FormModal
  },
  props: {},
  data() {
    return {
      columns: columns,
      dataSource: [],
      editColumns: columns.slice(2, columns.length - 1).map(item => ({
        dataIndex: item.dataIndex, //表格列key， month1,month2...
        month: item.title, //表格列名，2020-01,2020-02...
        monthNum: moment(item.title).month() //对应月份，0,1,2...
      })),
      breadcrumb: [
        {
          label: "待我审批详情",
          path: ""
        }
      ],
      defaultFillNone: false,
      canEdit: false,
      pageLayout: {},
      params: {},
      loadedLayout: true,
      loadedInfo: true,
      approvalFlowInfo: [],
      requestParams: {},
      cancelSource: null,
      confirmLoading: false,
      approvalModal: {
        visible: false,
        title: "打回",
        contentTitle: "你确定拒绝预算调整申请吗?",
        width: 560,
        formItemLayout: {
          layout: "vertical",
          labelCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 }
          }
        }
      },
      approvalInfolModal: [],
      visibleComment: false
    };
  },
  created() {
    this.requestParams = _.cloneDeep(this.params);
    this.fetchParams().then(() => {
      this.fetchLayout();
    });
  },

  methods: {
    fetchLayout() {
      this.loadedLayout = false;
      getBudgetChangeLayout({ id: this.$route.query.id, type: "detail" }).then(
        res => {
          if (res.status === "success") {
            this.pageLayout = res.data;
            this.pageLayout.contents.forEach(item => {
              if (item.type === "budgetAdjustTable") {
                item.initFinished = false;
                this.updateData(this.params[item.field]); // 预算调整表格数据格式化
                this.requestParams = _.cloneDeep(this.params);
                this.fetchApprovalFlow();
                item.initFinished = true;
              }
            });
            this.loadedLayout = true;
          } else {
            this.$Message.error(res.message);
          }
        }
      );
    },
    fetchParams() {
      this.loadedInfo = false;
      return getBudgetChangeDetailParams({
        id: this.$route.query.id,
        type: "detail"
      }).then(res => {
        if (res.status === "success") {
          this.params = res.data;
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    updateData(data) {
      UpdateData(data);
      this.requestParams = _.cloneDeep(this.params);
    },
    updateTable(e) {
      this.params[e.field] = e.data;
      UpdateData(this.params[e.field]);
      this.requestParams = _.cloneDeep(this.params);
    },

    back() {
      this.$router.replace({
        name: "waitApprovalList",
        query: {
          apply_type: 6
        }
      });
    },
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      LayoutConfig.setAllParams(this.params);
      this.requestParams = _.cloneDeep(this.params);
    },
    cancelQuest() {
      if (typeof this.cancelSource === "function") {
        this.cancelSource("终止请求"); //取消请求
      }
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      this.cancelQuest();
      getBudgetDetailApprovalFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    approval(e) {
      let validateResult = true;
      if (e) {
        this.$refs.commonForm.forEach(item => {
          if (!item.validateFields()) {
            validateResult = false;
          }
        });
      }
      if (!validateResult) {
        return;
      }
      if (this.fromLocation === "msg") {
        let params = {
          apply_id: this.$route.query.id,
          comment: this.comment
        };
        const url = e ? rejectApplicationApi : passApplicationApi;
        approvalApplication(url, params).then(res => {
          if (res.status === "success") {
            this.$Message.success("审批成功");
            location.reload();
          } else {
            this.$Message.error(res.message);
          }
        });
      } else {
        this.approvalModal.visible = true;
        if (e) {
          this.approvalInfolModal = agreeInfoFormModal;
          this.approvalModal.title = "同意";
          this.approvalModal.contentTitle = "你确定同意此预算调整申请吗";
          this.approvalStatus = 2;
        } else {
          this.approvalInfolModal = backInfoFormModal;
          this.approvalModal.title = "拒绝";
          this.approvalModal.contentTitle = "你确定拒绝此预算调整申请吗";
          this.approvalStatus = 3;
        }
      }
    },
    approvalModalSubmit(e) {
      let params = {
        apply_id: this.$route.query.id,
        comment: e.reason
      };
      this.confirmLoading = true;
      const url =
        this.approvalStatus === 3 ? rejectApplicationApi : passApplicationApi;
      approvalApplication(url, params).then(res => {
        if (res.status === "success") {
          this.approvalModal.visible = false;
          this.$Message.success("审批成功");
          this.back();
        } else {
          this.$Message.error(res.message);
        }
        this.confirmLoading = false;
      });
    },
    approvalModalCancel() {
      this.approvalModal.visible = false;
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
</style>
